import React from "react";
import { Reducer, HomeStateType, HomeDispatch } from "./reducer";

export const HomeStateContext = React.createContext<HomeStateType>({
  data: [],
});
export const HomeDispatchContext = React.createContext<
  HomeDispatch | undefined
>(undefined);

interface HomeProviderProps {}

type HomeProviderPropsType = React.PropsWithChildren<HomeProviderProps>;

export const HomeProvider: React.FC<HomeProviderPropsType> = ({
  children,
}: HomeProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {
    data: [],
  });
  return (
    <HomeDispatchContext.Provider value={dispatch}>
      <HomeStateContext.Provider value={state}>
        {children}
      </HomeStateContext.Provider>
    </HomeDispatchContext.Provider>
  );
};

export const useHomeState = () => {
  const state = React.useContext(HomeStateContext);
  return state;
};

export const useHomeDispatch = () => {
  const dispatch = React.useContext(HomeDispatchContext);
  return dispatch;
};
